import { addResourceBundle } from '@egw/i18n'
import en from './src/i18n/locales/en.json'

addResourceBundle('en', 'layouts', en)

export { DefaultLayout as Layout } from './src/default'
export * from './src/enrollment'
export * from './src/enrollment-hycs'
export * from './src/enrollment-multi'
export * from './src/enrollment-joint'
export * from './src/hooks'
export * from './src/pages/maintenance/maintenance'
export * from './src/components/redesign'
